module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('media-container', {
    attrs: {
      "issue": _vm.issue,
      "figures": _vm.issue.files.figures
    }
  }), _vm._v(" "), _c('issue-authors', {
    attrs: {
      "authors": _vm.issue.authors
    }
  }), _vm._v(" "), (_vm.issue.abstract) ? _c('div', {
    staticClass: "abstract",
    class: {
      hide: !_vm.isAbstractShow
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("ABSTRACT")]), _vm._v(" "), _c('div', {
    staticClass: "fullText",
    domProps: {
      "innerHTML": _vm._s(_vm.issue.abstract)
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.issue._id) ? _c('div', {
    staticClass: "article-quick-links"
  }, [_c('article-quick-links', {
    attrs: {
      "article": _vm.issue
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-131e4173"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/FullIssueComponent.vue
// module id = 1392
// module chunks = 1